export enum UnderwritingResult {
  Success = 'Success',
  FrozenReport = 'Frozen Report',
  Decline = 'Decline',
  BorrowerCannotBeCreated = 'Borrower Cannot Be Created',
  BorrowerAlreadyHasActiveApplication = 'Borrower Already Has Active Application',
  CoborrowerAlreadyHasActiveApplication = 'Co-Borrower Already Has Active Application',
  BorrowerIsLocked = 'Borrower Is Locked',
  CoborrowerIsLocked = 'Co-Borrower Is Locked',
}
